export default __webpack_public_path__ + "static/media/placeholder_dummy2016-klempner01-mobile-de.d7062526.png";